import React from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import { Typography } from '@mui/material';

const PREFIX = 'ErrorBlock';

const classes = {
  root: `${PREFIX}-root`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(2, 2),
    margin: theme.spacing(2, 2),
    textAlign: 'center',
    backgroundColor: theme.palette.error.light,
    '& p': {
      color: 'white',
    },
  },
}));

const ErrorBlock = ({ message }) => {
  if (!message) return null;
  return (
    <StyledPaper className={classes.root}>
      <Typography component='p'>{message}</Typography>
    </StyledPaper>
  );
};

ErrorBlock.propTypes = {
  message: PropTypes.string,
};

export default ErrorBlock;
